<template>
  <div class="expand_contract--container">
    <h3 v-on:click.prevent="expandContract" :title="tooltip">
      <a class="expand_contract--title" :title="tooltip" href="#">
        <svg class="expand_contract--icon_expand" v-show="!isExpanded">
          <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#symbol_arrow_down"></use>
        </svg>
        <svg class="expand_contract--icon_contract" v-show="isExpanded">
          <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#symbol_arrow_up"></use>
        </svg>
      </a>
      {{ title }}
    </h3>
    <div class="expand_contract--body" v-show="isExpanded">
      <div v-if="!similarRoomsHtml.length">
        <slot></slot>
      </div>
      <div v-if="similarRoomsHtml.length" class="body-container page-links">
        <div class="viewport">
          <div class="body-container-scroller" v-html="similarRoomsHtml" v-on:click="similarRoomsClickHandler"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {mapState} from 'vuex';
import {GetSimilarRoomsServerResponse} from "../../defs/serverResponse";

export default defineComponent({
  name: "view-room-details-expand-contract",
  props: {
    title: {
      type: String,
      required: true
    },
    isSimilarRooms: {
      type: Boolean,
      default: false
    },
    expanded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isExpanded: this.expanded,
      isLoading: false,
      similarRoomsHtml: ''
    };
  },
  watch: {
    '$store.state.showSimilarRooms'() {
      if (this.$store.state.showSimilarRooms) {
        if (this.isSimilarRooms && this.similarRoomsHtml.length === 0) {
          this.isExpanded = true;
          this.getSimilarRooms();
          this.$el.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }
    },
    '$store.state.similarRoomTowerOmit'() {
      //update similar rooms if the tower omit changes
      if (this.$store.state.showSimilarRooms) {
        if (this.isSimilarRooms && this.similarRoomsHtml.length !== 0) {
          this.getSimilarRooms();
        }
      }
    },
    '$store.state.currentPrtId'() {
      //if the room type variant changes, let's remove all similar rooms since they might have changed
      this.similarRoomsHtml = '';
      if (this.isExpanded && this.isSimilarRooms) {
        this.getSimilarRooms();
      }
    },
    isExpanded() {
      if (this.isExpanded) {
        //make sure the expanded content is in view
        const elTop = this.$el.getBoundingClientRect().top;

        if (elTop > window.innerHeight - 125) {
          let scroll = window.scrollY + this.$el.getBoundingClientRect().top;
          const header = document.querySelector('#header');
          if (header) {
            scroll -= header.clientHeight;
          }
          window.scrollTo({
            top: scroll,
            behavior: 'smooth'
          });
        }

      }
    }
  },
  computed: {
    ...mapState([
      'showSimilarRooms',
      'currentPrtId',
      'bookingLinkData',
      'similarRoomTowerOmit'
    ]),
    tooltip() {
      if (this.isExpanded) {
        return 'Click to hide';
      }
      return 'Click to show';
    }
  },
  methods: {
    expandContract() {
      this.isExpanded = !this.isExpanded;

      if (this.isSimilarRooms && this.similarRoomsHtml.length === 0 && this.isExpanded) {
        this.getSimilarRooms();
      }
    },
    getSimilarRooms() {
      if (0 === this.$store.state.currentPrtId) return;

      //track this interaction in GA
      window.pepTracking.event('ResNet View Similar Rooms', this.$store.getters.currentRoomTitle);

      this.isLoading = true;

      window.pepConsole.log('getSimilarRooms show loader');
      window.showLoader(true);

      $.ajax({
        url: '/library/api/resnet.php',
        type: 'post',
        dataType: 'json',
        data: {
          ACTION: 'GET_SIMILAR_ROOMS',
          ROOM_TYPE: this.$store.getters.currentRoomTitle,
          PRT_ID: this.$store.state.currentPrtId,
          CHECKIN_DATE: this.$store.state.bookingLinkData.start,
          CHECKOUT_DATE: this.$store.state.bookingLinkData.end,
          OFFER_CODE: this.$store.state.bookingLinkData.offerCode,
          SEND_LAYOUT: 'YES',
          MAX_RESULTS: 4,
          TOWER: this.$store.state.similarRoomTowerOmit,
          ADULTS: this.$store.state.bookingLinkData.adults || 2,
          CHILDREN: this.$store.state.bookingLinkData.children || 0
          //,CURRENT_PRICE	:	currentPrice
        },
        success: (response: GetSimilarRoomsServerResponse) => {

          window.hideLoader(false, true);

          let newHTML;

          if (response.STATUS === 'SUCCESS' && response.DATA.length) {

            newHTML = response.DATA.join('');

          } else {

            newHTML = '<div class="item hotel scrolled delay-0 icon-count-3 no-matches item-1" data-room-offer-codes="[&quot;&quot;,&quot;*TUSCANY&quot;]" data-search="{&quot;SQ-FT-LOW&quot;:550,&quot;SQ-FT-HIGH&quot;:550,&quot;BED&quot;:&quot;1-KING&quot;,&quot;BATH-COUNT&quot;:1}" data-page-id="50">\
								<div class="view">\
							<div class="img" data-img-src="/library/images/backgrounds/page-list-images/PR-Tuscan-Tower-1103-TwrKng-lo.jpg" style="background-position: 50% 50%; background-image: url(&quot;/library/images/backgrounds/page-list-images/PR-Tuscan-Tower-1103-TwrKng-lo.jpg&quot;);">\
								<div class="room-icons">\
									\
									\
								</div>\
							</div>\
							<h3 class="tooltip-dock-bottom" data-tooltip="No Matches Found">\
								<span class="clip">No Matches Found</span>\
							</h3><div class="item-body"><p>&nbsp;</p></div>\
							\
							<table class="details">\
								<tbody>\
									<tr>\
										<td class="filter-match-sq_ft"></td>\
										<td class="filter-match-bed_type"></td>\
										<td class="filter-match-bath_type"></td>\
									</tr>\
								</tbody>\
							</table>\
						</div>\
					</div>';

          }

          this.similarRoomsHtml = newHTML;

          requestAnimationFrame(function () {
            window.resetPageLinks();
            window.initTouchPageLinks($('.body-container').filter('.page-links'));
          });
        },
        error: (jqXHR, textStatus, errorThrown) => {

          //log this error
          const extraText = (typeof errorThrown === 'string')
            ? ' -- ' + errorThrown
            : '';
          window.pepTracking.event('JS Error', 'Load Similar Rooms', textStatus + extraText, 0, true);

          $.ajax({
            url: '/library/api/capture-js-error.php',
            dataType: 'json',
            type: 'post',
            data: {
              je_message: 'Load Similar Rooms',
              je_source: 'https://www.peppermillreno.com/library/js/view-room-details.min.js',
              je_lineno: 0,
              je_colno: 0,
              je_url: window.location.href,
              je_stack: "Status: " + jqXHR.status + "\n\nResponse Text:\n" + jqXHR.responseText
            }
          });
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },
    similarRoomsClickHandler(event: MouseEvent) {
      const eventTarget = event.target as HTMLAnchorElement | null;
      if (eventTarget?.classList.contains('help-icon')) {
        event.preventDefault();
        event.stopPropagation();

        const msg = eventTarget?.dataset.helpMsg;

        if (msg && msg.length) {

          window.pepConsole.log('similarRoomsClickHandler show loader');
          window.showLoader(false);

          window.showOverlayDialog({
            alertMode: true,
            confirmAccept: 'OK',
            confirmTitle: '',
            confirmBody: msg,
            callback: 'HIDE-OVERLAY'
          });

        }
      } else if (eventTarget?.classList.contains('view-similar-room')) {
        event.preventDefault();
        event.stopPropagation();
        window.pepTracking.event('ResNet View Similar Room Type', eventTarget?.closest('.similar-room').querySelector('h3').innerText || '', this.$store.getters.currentRoomTitle, 0, true);
        window.location.href = eventTarget?.href;
      }
    }
  }
})
</script>

<style>
.expand_contract--title {
  border: 2px solid #000;
  border-color: rgba(0, 0, 0, 0.87);
  border-radius: 50%;
  display: inline-block;
  height: 32px;
  margin-right: 24px;
  vertical-align: middle;
  width: 32px;
}

.expand_contract--title svg {
  height: 100%;
  width: 100%;
}

/*.expand_contract--title-collapsed .contract,
.expand_contract--title-expanded .expand {
  display	:	none;
}

.expand_contract--body-collapsed {
  display	:	none;
}*/


.expand_contract--container {
  border-bottom: 2px solid #E0E0E0;
  padding: 12px 0;
}

.expand_contract--container-renovations img {
  width: 100%;
}

.expand_contract--container-similar_rooms .expand_contract--body {
  margin-left: -12px;
  margin-right: -12px;
}

.expand_contract--container-similar_rooms .expand_contract--body .body-container {
  padding-left: 0;
  padding-right: 0;
}

.expand_contract--container > h3 {
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.expand_contract--container-similar_rooms .page-links .item h3 {
  border-bottom: none;
  font-size: 1.2em;
  text-transform: none;
}

.expand_contract--container-similar_rooms .page-links .item:after {
  display: none;
}

.expand_contract--container-similar_rooms .price {
  font-size: 1.2em;
  position: relative;
  margin: 12px;
  text-align: center;
  z-index: 30;
}

/*.price-positive {
  position	:	relative;
}

.price-positive::before {
  content		:	'+';
  position	:	relative;
}

.price-negative {
  color		:	green;
  position	:	relative;
}

.price-negative::before {
  content		:	'-';
  position	:	relative;
}*/

.expand_contract--container-similar_rooms .body-container.page-links .viewport .body-container-scroller {
  grid-template-columns:	1fr 1fr;
}

.ui-tablet .expand_contract--container-similar_rooms .page-links .item:nth-child(n + 3),
.ui-desktop .expand_contract--container-similar_rooms .page-links .item:nth-child(n + 4),
.ui-widescreen .expand_contract--container-similar_rooms .page-links .item:nth-child(n + 4) {
  display: block;
}

.expand_contract--container .body-container {
  padding: 16px;
}

.expand_contract--container-similar_rooms .body-container .viewport {
  padding-left: 0;
  padding-top: 0;
  padding-right: 0;
}

.expand_contract--container-similar_rooms .body-container .viewport .body-container-scroller {
  padding-left: 12px;
}

.ui-tablet .expand_contract--container .body-container.page-links .viewport {
  padding: 0;
}


a.view-similar-room {
  width: 100%;
}

.room-info + a.view-similar-room {
  border-radius: 0 0 4px 4px;
}

h3 + a.view-similar-room {
  cursor: default;
}


@media (max-width: 800px) {
  .expand_contract--container > h3 {
    padding: 0 16px;
  }
}
</style>